import WinsonModule from "@/modules/winson";

export const WinsonPage = () => {
  return (
    <div>
      <WinsonModule />
    </div>
  );
};
